import { useQuery } from '@tanstack/react-query';
import { awsUserApi } from '@/lib/aws-api-client';

interface UserProfile {
  user_id: string;
  email: string;
  name: string;
  plan_type: string;
  subscription_status: string;
  created_at?: number; // Unix timestamp in seconds
}

export function useUserProfile(userEmail?: string | null) {
  return useQuery<UserProfile>({
    queryKey: ['userProfile', userEmail],
    queryFn: () => awsUserApi.getProfile(userEmail!),
    enabled: !!userEmail,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
